<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->

            </div>

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 15%; margin-right: 15%;">
                <div aling="center">
                    <img src="./assets/images/norm35/Mesa de trabajo 12.png" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <div>
                    <p>Aspectos a verificar durante la evaluación de la conformidad de la Norma</p>
                </div>

                <table class="table customTable">
                    <thead>
                        <tr>
                            <th scope="col">Disposición</th>
                            <th scope="col">Tipo </th>
                            <th scope="col">Criterio de aceptación</th>
                            <th scope="col">Observaciones</th>
                            <th scope="col">Riesgo</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let datita of aspects; let i = index">
                        <tr>
                            <th scope="row">{{datita.disposicion}}</th>
                            <th scope="row">{{datita.tipo}}</th>
                            <th scope="row">
                                <div *ngFor="let datacriterio of datita.criterio">
                                    {{datacriterio.descripcion}}
                                    <mat-divider></mat-divider>
                                </div>
                            </th>
                            <th scope="row">
                                <div *ngFor="let dataobservaciones of datita.observaciones">
                                    {{dataobservaciones.descripcion}}
                                    <mat-divider></mat-divider>
                                </div>

                            </th>
                            <th scope="row"></th>

                        </tr>
                    </tbody>
                </table><br><br>



            </div>


            <!--<div *ngIf=" dataId.id == datita.position ">-->




        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->
